import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { isEqual } from "lodash";
import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

import { EXPENSE_REPORT_STATUS } from "../../../utils/constants/constants";

import { Props, State, ExpenseReportStatusOptionValue, ExpenseReportStatusQuickFilter } from "./interfaces";
import { TravelExpenseTypeRef } from "../../../models/travel-expense-types";

export const ExpenseReportStatusQuickfilter = <Q extends ExpenseReportStatusQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
  forManager,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.expense_report_status"; // tRP - translation root path

  const employeeOption = {
    name: `${t(`${tRP}.options.require_action`)}`,
    value: {
      expenseReportStatusIds: [EXPENSE_REPORT_STATUS.draft.id, EXPENSE_REPORT_STATUS.returned_to_employee.id],
    },
  };
  const [state, setState] = useState<State>({
    options: [
      {
        name: `${t(`common_words.all`)}`,
        value: { expenseReportStatusIds: [] },
      },
      {
        name: forManager ? `${t(`${tRP}.options.require_action`)}` : `${t(`${tRP}.options.pending_for_approval`)}`,
        value: {
          expenseReportStatusIds: [EXPENSE_REPORT_STATUS.submitted.id, EXPENSE_REPORT_STATUS.approved.id],
        },
      },
    ],
  });

  return (
    <QuickFilter
      options={forManager ? [...state.options] : [...state.options, employeeOption]}
      quickFilters={quickFilters}
      quickFilter="expenseReportStatuses"
      handleChangeQuickFilter={handleChangeQuickFilters}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
    />
  );
};
